import Http from '../API'

const device = {
  state: {
    device_group: [],
    device_group_tree: [],
    device_list: {},
    devices_data: {},
    device_list_change: false,
    device_filter:{
      server: [],
      group: [],
      desc: [],
      place: [],
      name: [],
      ip: [],
      custom_list:[],
      client_id:[],
      device_sku_id:[],
      versions: {},
      status: {
        online: 1,
        backup: 0,
        blocked: 0,
        tariffication: 0
      },
      visible: false,
      single_simcard: false,
      not_version: false,
      exclude_groups: false,
      universal_search: ""
    },
    device_list_checked: {},
  },
  getters:{
    getTreeByClientIds: (state) => (ids) => {
      let tree = []
      return device.mutations.searchElementInTree(state.device_group_tree, ids, tree)
    },
    getPathGroupById: (state) => (id) => {
      let path = []
      return device.mutations.searchParentByGroupId(state.device_group, id, path)
    },
    getDeviceGroups: (state) => {
      return state.device_group
    },
    getDeviceGroupsTree: (state) => {
      return state.device_group_tree
    },
    getDeviceGroupById: (state) => (id, parent) => {
      for (let i in state.device_group) {
        if (+state.device_group[i].id === +id) {
          return state.device_group[i]
        }
      }
      if(!parent) {
        device.mutations.deviceGroupUpdate(state, [...state.device_group,  {'name': 'unknown', 'id': id, 'status': 'unknw', parent: -1 }])
      }
      return state.device_group[state.device_group.length - 1]
    },
    getSelectGroup: (state) => () => {
      let group = []
      for (let j in state.device_filter.group) {
        for (let i in state.device_group) {
          if (+state.device_group[i].id === +state.device_filter.group[j]) {
            group.push(state.device_group[i])
          }
        }
      }
      return group
    },
    getDeviceById: (state) => (id) => {
      if (state.devices_data[id] && state.devices_data[id].profile) {
        if (state.devices_data[id].profile.ts) {
          return state.devices_data[id]
        }
      } else {
        state.devices_data[id] = { profile: null, stats: { ts_start: -1, data: null }, load: true }
        return state.devices_data[id]
      }
    },
    _getDeviceById: (state) => (id) => {
      for (let group in state.device_list) {
        if(state.device_list[group][id]){
          return state.device_list[group][id]
        }
      }
      return null
    },
    getDeviceLinks: (state) => {
      return state.device_list
    },
    getDeviceListChange: (state) => {
      return state.device_list_change
    },
  },
  mutations: {
    searchElementInTree(parent, ids, tree){
      for (let child of parent) {
        if (ids.indexOf(child.client_id) > -1 ){
          tree.push(child)
        }else if(child.children && child.children.length > 0){
          device.mutations.searchElementInTree(child.children, ids, tree)
        }
      }
      return tree
    },
    searchParentByGroupId(parent, id, path){
      for (let child of parent) {
        if (child.id === id) {
          if (child.parent !== -1) {
            path.push(child.parent)
            device.mutations.searchParentByGroupId(parent, child.parent, path)
          }
        }
      }
      return path
    },
    deviceGroupUpdate (state, groups) {
      state.device_group = groups
      let group = {}
      let id = 0
      for(let i in state.device_group) {
        group[state.device_group[i].id] = { ...state.device_group[i], label: state.device_group[i].name, search_text: state.device_group[i].name, isDefaultExpanded:true, expanded: true }
      }

      for(let i in state.device_group) {
        id = state.device_group[i].id
        if(state.device_group[i].parent !== -1) {
          if(group[state.device_group[i].parent] === undefined) {
            group[id].parent = -1
          } else {
            if(group[state.device_group[i].parent].children === undefined) {
              group[state.device_group[i].parent].children = [];
            }
            group[state.device_group[i].parent].children.push(group[id]);
            group[id].search_text += ' ' + group[state.device_group[i].parent].name //field for search
          }
        }
      }
      let root_group  = []

      for(let i in group) {
        if(group[i].parent === -1 && group[i].id !== 0) {
          root_group.push(group[i])
        }
      }

      root_group = root_group.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)
      if (group[0]){
        root_group.unshift(group[0])
      }

      state.device_group_tree = root_group
    },

    setDeviceFilter (state, filter) {
      if (filter === null) {
        return false
      }
      state.device_filter = filter
    },

    add_link_group_device (state, id) {
      if (state.device_list[id] === undefined ) {
         state.device_list[id] = {}
      }
      state.device_list = {...state.device_list}
    },

    clear_history_device(state, link) {
      let main_link = link.link
      for (let child of main_link.children) {
        delete state.device_list[child.id]
      }
      state.device_list = {...state.device_list}
    },

    delete_link_device (state, link) {
      if (state.device_list[link.group] !== undefined && state.device_list[link.group][link.id]) {
        for (let i in state.device_group) {
          if (+state.device_group[i].id === +link.group ) {
            if (+state.device_group[i].parent !== -1 ) {
              state.device_list[state.device_group[i].parent] = {}
            }
            break;
          }
        }
        delete state.device_list[link.group][link.id]
      }
      state.device_list = {...state.device_list}
    },

    delete_link_group_device (state, params) {
      for( let id of params.ids ) {
        if (state.device_list[id] !== undefined ) {
          delete state.device_list[id]
        }
      }
      if(params.parent !== undefined && +params.parent !== -1) {
        state.device_list[params.parent] = {}
      }
      state.device_list = {...state.device_list}
    },

    updateDeviceProfile (state, dev) {
      let oldDevice = state.devices_data[dev.fid]

      let tmp = {...dev}
      delete tmp['ts']
      oldDevice['hash'] = JSON.stringify(tmp)
      oldDevice['profile'] = {...dev}

      oldDevice['load'] = false
      state.devices_data = {...state.devices_data}

      device.mutations.updateDeviceList(state, dev)
    },

    updateDeviceList (state, device) {
      if(state.device_list[device.user_info.group_id] === undefined) {
        state.device_list[device.user_info.group_id] = {}
      }

      let name= ''
      if (name.trim() === '') {
        name = (state.devices_data[device.fid].profile?.user_info?.name2 && state.devices_data[device.fid].profile.user_info.name2.trim() !== '') ? state.devices_data[device.fid].profile.user_info.name2 : state.devices_data[device.fid].profile.fid
      }

      if (!state.device_list[device.user_info.group_id][device.fid] || state.device_list[device.user_info.group_id][device.fid].name !== name) {
        state.device_list[device.user_info.group_id][device.fid] = {
          name: name,
          icon: 'mdi-subdirectory-arrow-right',
          path: '/device/' + state.devices_data[device.fid].profile.fid
        }
        state.device_list = {...state.device_list}
      }
    },

    setNotExistDevice (state, id) {
      let oldDevice = state.devices_data[id]
      oldDevice.load = false
      state.devices_data = {...state.devices_data}
    },

    updateDeviceStats (state, device) {
      let oldDevice = state.devices_data[device.id]
      oldDevice['stats'] = {...device}
      state.devices_data = {...state.devices_data}
    },

    setDeviceListChange (state, status) {
      state.device_list_change = status
    },

    clearDevice (state) {
      state.device_list = {}
      state.device_filter = {
        server: [],
        group: [],
        desc: [],
        place: [],
        name: [],
        ip: [],
        custom_list:[],
        client_id:[],
        device_sku_id:[],
        versions: {},
        status: {
          online: 1,
          backup: 0,
          blocked: 0,
          tariffication: 0
        },
        visible: false,
        single_simcard: false,
        not_version: false,
        exclude_groups: false,
        universal_search: ""
      }
      state.deviceListChecked = {}
    },
  },
  actions: {
    clear_history_device (context, id) {
      context.commit('clear_history_device', id)
    },

    delete_link_device (context, id) {
      context.commit('delete_link_device', id)
    },

    add_link_group_device (context, id) {
      context.commit('add_link_group_device', id)
    },

    delete_link_group_device (context, params) {
      context.commit('delete_link_group_device', params)
    },

    async deviceGroupUpdate () {
      await Http.v1.getGroupList((response) => {
        this.commit('deviceGroupUpdate', response.data)
        this.commit('donePreloadName', 'deviceGroupUpdate')
      })
    },

    setDeviceFilter (context, filter) {
      context.commit('setDeviceFilter', filter)
    },

    updateDeviceList (context, dev) {
      if (dev){
        context.commit('updateDeviceList', dev)
      }
    },

    updateDeviceProfile (_, id) {
      Http.v1.getDeviceProfile(id, (response) => {
        this.commit('updateDeviceProfile', { ts: Date.now() + 60000, ...response.data })
      }, () => {
        this.commit('setNotExistDevice',  id)
      })
    },
  }
}

export default device
